const INITIAL_STATE = {
  noteList: {},
  note: {},
  errors: {},
}

const accountNotes = (state = INITIAL_STATE, action) => {
  switch (action.type) {
  case 'ADD_ACCOUNT_NOTES':
    return { ...state, ...INITIAL_STATE, note: action.data }
  case 'ADD_ACCOUNT_NOTES_FAILED':
    return { ...state, ...INITIAL_STATE, errors: action.data }
  case 'GET_ACCOUNT_NOTES':
    return { ...state, ...INITIAL_STATE, noteList: action.data }
  case 'GET_ACCOUNT_NOTES_FAILED':
    return { ...state, ...INITIAL_STATE, errors: action.data }
  default:
    return { ...state }
  }
};

export default accountNotes;
